
const gift = (state = {
  giftAmount: 0,
}, action) => {
  switch (action.type) {
    case 'SET_GIFT_AMOUNT':
      return {
        ...state,
        giftAmount: action.giftAmount,
      };
    case 'SET_GIFT_RECIPIENT':
      return {
        ...state,
        recipientEmail: action.recipientEmail
      };
    case 'SET_GIFT_SENDER':
      return {
        ...state,
        senderEmail: action.senderEmail
      };
    case 'SET_TEMPLATE':
      return {
        ...state,
        template: action.template
      };
    case 'SET_NOTE':
      return {
        ...state,
        note: action.note
      };
    default:
      return state
  }
};


export default gift



// WEBPACK FOOTER //
// ./src/Reducers/gift.js